export class FooterBase
{
	constructor()
	{
		this.Initialize();
	}

	public Initialize()
	{
	}
}